import { memo } from "react";

const LINER_GRADIENT_ID = "FAVORITE";

interface Props {
  className?: string;
}

const FavoriteIcon = memo(({ className }: Props) => {
  return (
    <svg
      height="20"
      viewBox="0 0 24 20"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <linearGradient
        id={LINER_GRADIENT_ID}
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0" stopColor="#B647B7" />
        <stop offset="1" stopColor="#F683B6" />
      </linearGradient>
      <path
        d="m0 6.37306667c0-3.60066667 3.15885333-6.37306667 6.86666667-6.37306667 1.91129333 0 3.59306663.89618667 4.80000003 2.05577333 1.2069333-1.15958666 2.8886666-2.05577333 4.8-2.05577333 3.7078666 0 6.8666666 2.7724 6.8666666 6.37306667 0 2.46653333-1.0518666 4.63546663-2.5090666 6.46893333-1.4548 1.8304-3.3576 3.3837333-5.1796 4.646-.696.4821333-1.4.9268-2.0442667 1.2549333-.6050667.3081334-1.3008.5904-1.9337333.5904-.6329334 0-1.3286667-.2822666-1.93373337-.5904-.64426666-.3281333-1.34832-.7728-2.04422666-1.2549333-1.82197334-1.2622667-3.72488-2.8156-5.17961334-4.646-1.45725333-1.8334667-2.50909333-4.0024-2.50909333-6.46893333zm6.86666667-4.37306667c-2.77233334 0-4.86666667 2.0388-4.86666667 4.37306667 0 1.87133333.79438667 3.6136 2.07478667 5.22453333 1.28292 1.6141333 3.00910666 3.0382667 4.75286666 4.2464.65981334.4570667 1.28127997.846 1.81301337 1.1168.5708.2906667.9016.3725333 1.026.3725333s.4552-.0818666 1.026-.3725333c.5317333-.2708 1.1532-.6597333 1.8130666-1.1168 1.7437334-1.2081333 3.4698667-2.6322667 4.7528-4.2464 1.2804-1.61093333 2.0748-3.3532 2.0748-5.22453333 0-2.33426667-2.0944-4.37306667-4.8666666-4.37306667-1.5922667 0-3.0789334.95122667-4.0072 2.15856-.1893334.24618667-.4822667.39045333-.7928.39045333-.3105334 0-.6034667-.14426666-.7928-.39045333-.9282667-1.20733333-2.41500003-2.15856-4.00720003-2.15856z"
        fill={`url(#${LINER_GRADIENT_ID})`}
        fillRule="evenodd"
        transform="translate(.333333)"
      />
    </svg>
  );
});

export default FavoriteIcon;
